// import { apiService } from '../services';
// import Vue from 'vue';
// import router from '../router';

const state = {
};

const getters = {
  // getItem: state => (itemId) => {
  //   const item = state.items.find(item => item.id === itemId);
  //   return item === undefined ? null : item;
  // },
  // itemsOpen(state) {
  //   return state.items.filter(item => ((item.status !== 'pending') && ((item.status !== 'done'))));
  // },
};

const actions = {
  // async getItems({ commit, dispatch }) {
  //   dispatch('alert/busy', null, { root: true });
  //   try {
  //     const items = await apiService.getItems();
  //     dispatch('alert/clear', null, { root: true });
  //     commit('popItems', items);
  //   } catch (error) {
  //     dispatch('alert/error', error, { root: true });
  //   }
  // },
  // async addItem({ dispatch }, item) {
  //   try {
  //     dispatch('alert/busy', null, { root: true });
  //     const res = await apiService.addItem(item);
  //     const msg = 'Item success';
  //     dispatch('alert/success', msg, { root: true });
  //     router.push({ name: 'itemok', params: { itemId: res.id } });
  //   } catch (error) {
  //     dispatch('alert/error', error, { root: true });
  //   }
  // },
  // async deleteItem({ dispatch, commit }, item) {
  //   dispatch('alert/busy', null, { root: true });
  //   try {
  //     await apiService.deleteItem(item);
  //     const msg = 'Item canceled';
  //     dispatch('alert/success', msg, { root: true });
  //     commit('removeItem', item);
  //   } catch (error) {
  //     dispatch('alert/error', error, { root: true });
  //   }
  // },
  // async updateItem({ dispatch, commit }, item) {
  //   commit('setItemBusy', item);
  //   try {
  //     await apiService.updateItem(item);
  //     commit('clearItemBusy', item);
  //     commit('updateItem', item);
  //   } catch (error) {
  //     commit('clearItemBusy', item);
  //     dispatch('alert/error', error, { root: true });
  //   }
  // },
  // SOCKET_myActionSocket({ rootState, commit }, item) {
  //   // Websocket message on itemEvent channel
  //   if (rootState.account.account.user.type !== 'customer') {
  //     // Only fetch new items for service people
  //     commit('removeItem', item);
  //   }
  // },
};

const mutations = {
  // popItems(state, items) {
  //   state.items = items;
  // },
  // removeItem(state, item) {
  //   state.items = state.items.filter(item => item.id !== item.id);
  // },
  // updateItem(state, item) {
  //   // Check if item status is done. If so, we can just go ahead and remove it.
  //   if (item.status === 'done') {
  //     state.items = state.items.filter(item => item.id !== item.id);
  //   } else {
  //     const updatedItem = item;
  //     // Remove old item, and replace with new one
  //     const indexOfItem = state.items.findIndex(item => item.id === updatedItem.id);
  //     Vue.set(state.items, indexOfItem, updatedItem);
  //   }
  // },
  // SOCKET_myMutationSocket(state, { item, status }) {
  //   const oldItem = state.items.find(item => item.id === item);
  //   const updatedItem = { ...oldItem };
  //   updatedItem.status = status;
  //   // Replace item in state
  //   const indexOfItem = state.items.findIndex(item => item.id === item);
  //   Vue.set(state.items, indexOfItem, updatedItem);
  // },
};

export const item = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/item.module.js